// extracted by mini-css-extract-plugin
module.exports = {"intro-card":"introduction-card-m__intro-card__3QwP9"};